import { render, staticRenderFns } from "./EventLogPage.vue?vue&type=template&id=38ac68fd"
import script from "./EventLogPage.vue?vue&type=script&lang=js"
export * from "./EventLogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports